import { ChevronRight, ExternalLink } from "lucide-react";
import { Stream } from "./Cell";
import { GbifMap } from "./GbifMap";

export const GbifPanel = ({ gbif, country, bbox }) => {
  if (!gbif || !gbif.usageKey) return <Stream kind="stderr" testid="gbif-no-match">{"KeyError: 'usageKey' — no GBIF backbone match for top prediction"}</Stream>;
  const key = gbif.acceptedUsageKey || gbif.usageKey;
  const occ = gbif.occurrences || {};
  return (
    <div className="space-y-4" data-testid="gbif-panel">
      <div data-testid="gbif-taxonomy-breadcrumb" className="flex flex-wrap items-center gap-1 text-[13px]">
        {gbif.hierarchy.map((h, i) => (
          <span key={h.rank} className="flex items-center gap-1">
            <span className="rounded border bg-secondary/60 px-2 py-0.5"><span className="text-[10px] font-mono uppercase text-muted-foreground mr-1">{h.rank}</span><span className={h.rank === "species" || h.rank === "genus" ? "italic" : ""}>{h.name}</span></span>
            {i < gbif.hierarchy.length - 1 && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />}
          </span>
        ))}
      </div>
      <div className="grid md:grid-cols-12 gap-5">
        <div className="md:col-span-5 space-y-3">
          <table className="text-[13px] w-full">
            <tbody>
              {[["usageKey", gbif.usageKey], ["scientificName", gbif.scientificName], ["status", gbif.status], ["matchType", gbif.matchType], ["confidence", `${gbif.confidence}`], ["order == Lepidoptera", String(gbif.is_lepidoptera)]].map(([k, v]) => (
                <tr key={k} className="odd:bg-secondary/70"><td className="px-2 py-1 font-mono text-xs font-semibold">{k}</td><td data-testid={`gbif-field-${k.split(" ")[0]}`} className="px-2 py-1 text-right">{v}</td></tr>
              ))}
            </tbody>
          </table>
          <div className="rounded border p-3">
            <div className="text-[11px] font-mono text-muted-foreground">occ["count"]</div>
            <div data-testid="gbif-occurrence-count" className="font-mono font-bold text-2xl">{(occ.count || 0).toLocaleString()}</div>
            <div className="flex flex-wrap gap-1.5 mt-2">{(occ.top_countries || []).map((c) => <span key={c.name} className="text-[11px] font-mono rounded bg-secondary px-1.5 py-0.5">{c.name}: {c.count.toLocaleString()}</span>)}</div>
          </div>
          <a data-testid="gbif-species-link" href={`https://www.gbif.org/species/${key}`} target="_blank" rel="noreferrer" className="text-xs text-primary inline-flex items-center gap-1 hover:underline">gbif.org/species/{key} <ExternalLink className="h-3 w-3" /></a>
        </div>
        <figure className="md:col-span-7 max-w-md">
          <GbifMap testid="gbif-map-container" taxonKey={key} country={country} bbox={bbox} />
          <figcaption className="text-[11px] font-mono text-muted-foreground mt-1">Fig. GBIF occurrence density (hex-binned, drag / zoom), taxonKey={key}{country ? `, country=${country}` : ""}</figcaption>
        </figure>
      </div>
    </div>
  );
};
